import { useSelector } from "react-redux";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";

const Confirm = (props: any) => {
  const device = useSelector((state: any) => state.commonplace.device);
  const cancelOperate = () => {
    if (props.info.loading) return;
    props.setIsModalOpen(
      Object.assign({}, props.info, {
        show: false,
      })
    );
  };

  const saveOperate = () => {
    if (props.info.loading) return;
    props.submitEvt(props.info.id ? props.info.id : null);
  };

  return (
    <>
      {device === "computer" ? (
        <Dialog open={props.info.show}>
          <DialogContent className="sm:max-w-xl p-0 overflow-hidden border-0">
            <DialogTitle className="sr-only">{props.info.title}</DialogTitle>
            <div className="bg-primary text-primary-foreground px-6 py-4 text-xl font-semibold">
              {props.info.title}
            </div>
            <div className="px-6 py-6 text-foreground">
              <div className="text-base">{props.info.question}</div>
              <div className="mt-6 grid grid-cols-2 gap-4">
                <Button
                  variant="outline"
                  className="border-primary text-primary"
                  onClick={cancelOperate}
                >
                  {props.btns ? <>{props.btns[0]}</> : "Cancel"}
                </Button>
                <Button
                  className="bg-primary text-primary-foreground"
                  onClick={saveOperate}
                >
                  {props.btns ? <>{props.btns[1]}</> : "Confirm"}
                </Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      ) : (
        <Dialog open={props.info.show}>
          <DialogContent className="sm:max-w-xl p-0 overflow-hidden border-0">
            <DialogTitle className="sr-only">{props.info.title}</DialogTitle>
            <div className="bg-primary text-primary-foreground px-4 py-3 text-lg font-semibold">
              {props.info.title}
            </div>
            <div className="px-4 py-4 text-foreground">
              <div className="text-sm">{props.info.question}</div>
              <div className="mt-4 grid grid-cols-2 gap-3">
                <Button
                  variant="outline"
                  className="border-primary text-primary"
                  onClick={cancelOperate}
                >
                  {props.btns ? <>{props.btns[0]}</> : "Cancel"}
                </Button>
                <Button
                  className="bg-primary text-primary-foreground"
                  onClick={saveOperate}
                >
                  {props.btns ? <>{props.btns[1]}</> : "Confirm"}
                </Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default Confirm;
